import React from 'react';

import type { Product } from './athletes';

type ProductCardProps = {
    product: Product;
};

export function ProductCard({ product }: ProductCardProps) {
    return (
        <a className="product-card" href={product.url}>
            <img
                className="product-card__image"
                src={product.image}
                alt={product.title}
            />
            <div className="product-card__text">
                <div className="product-card__brand faves-eyebrow--small">{product.brand}</div>
                <div className="product-card__title">{product.title}</div>
                <div className="product-card__price">{product.price}</div>
            </div>
        </a>
    );
}
